// @file Helpers for the PerformanceOverlay component
import environment from '@@/bits/environment'
import { getSearchParam } from '@@/bits/location'

const queryParamFlag = getSearchParam('performance_overlay')

const showPerformanceOverlay = environment === 'development' && (queryParamFlag === 'true' || queryParamFlag === '1')
export { showPerformanceOverlay }
